import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Flex, Box, Table, IconButton, Input, Card, VStack, HStack, Separator, Collapsible, Drawer, Container, Portal } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil, LuMessageCircle } from "react-icons/lu"
import {

    FileUpload,
    Float,
    useFileUploadContext,
} from "@chakra-ui/react"
import { LuFileImage, LuX } from "react-icons/lu"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import OrderService from "services/order"
import ImageService from "services/image"
import { useNavigate, useParams } from "react-router"
import { useStore } from "contexts/store";
import { useChat } from "contexts/chat";
const service = new OrderService();
const imageService = new ImageService();

const Cart = () => {
    const { setProcessing, setPageTitle, showToast } = useApp();
    const navigate = useNavigate();
    const { store } = useStore();
    const { openChat, hasChatEntry } = useChat();
    const [order, setOrder] = useState({})
    const [submittingCod, setSubmittingCod] = useState(false)

    const [openConfirmBox, setOpenConfirmBox] = useState(false);
    const fileFef = useRef([])

    const { id } = useParams();
    const codEnabled = !!store?.order_setting?.cod_enabled;



    useEffect(() => {
        loadData();
        setPageTitle("Thanh toán")
    }, [id])

    const loadData = async () => {
        window.scrollTo(0, 0);

        var data = await service.get(id);
        if (data) {
            setOrder(data);
        }

    }












    const downloadPDF = async () => {
        try {
            var url = order.invoice_file;
            var filename = order.id + ".pdf";
            // Fetch the PDF data as a Blob
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a download link and set its attributes
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            // Append the link to the document, click it, and remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error while downloading PDF:', error);
        }
    }


    const downLoadInvoiceFile = async () => {
        setProcessing(true)
        var data = await service.createInvoiceFile({ id: order.id });
        setProcessing(false);
        if (data) {

            window.location = data.invoice_file;
        }

    }

    const paymentCOD = async () => {
        if (!order?.id) {
            return;
        }

        try {
            setSubmittingCod(true);
            await service.paymentCOD({ id: order.id });
            showToast({ description: "Đã ghi nhận thanh toán khi nhận hàng cho đơn của bạn.", type: "success", duration: 5000 });
            navigate("/order/" + order.id)
        } catch (error) {
            showToast({ description: error?.message || "Không thể cập nhật hình thức thanh toán", type: "error", duration: 5000 });
        } finally {
            setSubmittingCod(false);
        }
    }




    return (
        <div style={{ paddingBottom: 75 }}>

            <div >


                <Stack gap="4" align="flex-start" maxW="sm">

                    <div style={{ display: "flex", gap: 8, flexDirection: "column" }}>
                        <div>
                            Cảm ơn bạn đã đặt hàng!
                        </div>
                        <div>
                            Vui lòng thanh toán theo thông tin bên dưới để chúng tôi tiến hành xử lý đơn hàng của bạn.
                        </div>


                    </div>
                    <Table.Root size="sm" >

                        <Table.Body>
                            {/* 
                            <Table.Row >
                                <Table.Cell>        Cảm ơn bạn đã đặt hàng</Table.Cell>

                            </Table.Row> */}

                            <Table.Row >
                                <Table.Cell>
                                    Mã đơn hàng:
                                    <Text fontWeight={"semibold"} display={"inline"}>{order.id}</Text>
                                </Table.Cell>

                            </Table.Row>

                            <Table.Row >
                                <Table.Cell>
                                    Tổng thanh toán:
                                    <Text fontWeight={"semibold"} display={"inline"}> {formatCurrency(order.total_amount)}</Text>
                                </Table.Cell>

                            </Table.Row>

                            <Table.Row >
                                <Table.Cell>

                                    <div style={{ display: "flex", gap: 8, flexDirection: "column" }}>
                                        <div>
                                            Thông tin thanh toán
                                        </div>

                                        <div>
                                            Ngân hàng:   <Text fontWeight={"semibold"} display={"inline"}>{store.bank_tranfer.bank_short_name}</Text>
                                        </div>
                                        <div>
                                            Số tài khoản:    <Text fontWeight={"semibold"} display={"inline"}> {store.bank_tranfer.account}</Text>
                                        </div>
                                        <div>
                                            Chủ tài khoản:   <Text fontWeight={"semibold"} display={"inline"}>   {store.bank_tranfer.name} </Text>
                                        </div>
                                        <div>
                                            Nội dung:  <Text fontWeight={"semibold"} display={"inline"}>  {order.id}</Text>
                                        </div>




                                    </div>
                                    <Collapsible.Root>
                                        <Collapsible.Trigger><Button variant={"ghost"}>Mã QR chuyển khoản</Button></Collapsible.Trigger>
                                        <Collapsible.Content>
                                            <Center>
                                                <Image src={`https://img.vietqr.io/image/${store.bank_tranfer.bank_bin}-${store.bank_tranfer.account}-print.png?amount=${order.total_amount}&addInfo=${order.id}&accountName=${encodeURIComponent(store.bank_tranfer.name)}`} style={{ maxWidth: "100%" }}></Image>

                                            </Center>
                                        </Collapsible.Content>
                                    </Collapsible.Root>
                                    <div style={{ fontStyle: "italic" }}>
                                        <Text color={"red.400"}>
                                            Vui lòng chụp ảnh màn hình chuyển khoản và nhấn  'Tôi đã thanh toán' để giúp chúng tôi xác nhận nhanh hơn.
                                        </Text>

                                    </div>
                                </Table.Cell>

                            </Table.Row>







                        </Table.Body>
                    </Table.Root>
                    <Box bg="bg" shadow="md" borderRadius="md" style={{ padding: 8, width: "100%" }}>
                        <Flex gap="4" justifyContent={"center"} flexDirection={"column"}>

                            <Button variant={"solid"} onClick={e => setOpenConfirmBox(true)}  >
                                Tôi đã thanh toán
                            </Button>

                            {codEnabled &&
                                <Button variant={"outline"} loading={submittingCod} onClick={paymentCOD}>
                                    Thanh toán khi nhận hàng
                                </Button>
                            }

                            {hasChatEntry &&
                                <Button
                                    variant={"outline"}
                                    onClick={e => openChat({
                                        chatAttachment: {
                                            type: "order",
                                            title: `Đơn hàng #${order?.id}`,
                                            meta: { order_id: order?.id },
                                        }
                                    })}
                                >
                                    Hỗ trợ xử lý đơn hàng
                                </Button>
                            }

                            <Button variant={"outline"} onClick={e => navigate("/order/" + order.id)}   >
                                Trở về
                            </Button>



                        </Flex>
                    </Box>










                </Stack>



            </div>


            <PaymentConfirmPopup open={openConfirmBox} onClose={e => setOpenConfirmBox(false)} order_id={order.id}></PaymentConfirmPopup>
        </div >
    )
}

const PaymentConfirmPopup = ({ open, onClose, order_id }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { setProcessing, showToast } = useApp();
    const navigate = useNavigate();
    useEffect(() => {
        setIsOpen(open);

    }, [open])
    const fileFef = useRef([])
    fileFef.current = [];
    const close = () => {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }


    const onOpenChange = (e) => {
        if (!e.open) {
            close();
        } else {
            setIsOpen(e.open)
        }
    }

    const onFileChange = (file) => {
        console.log(file)
        fileFef.current = file.acceptedFiles;
    }

    const paymentConfirm = async () => {

        console.log(fileFef.current);
        var files = [];
        setProcessing(true)
        for (let index = 0; index < fileFef.current.length; index++) {
            const element = fileFef.current[index];
            var image = await imageService.uploadFile(element);
            files.push(image)

        }

        await service.paymentProof({ id: order_id, image: files[0] });



        console.log("files", files);

        setProcessing(false);
        showToast({ description: "Cảm ơn bạn! Chúng tôi đã ghi nhận thông tin thanh toán và sẽ xác nhận trong thời gian sớm nhất.", type: "success", duration: 6000, })
        close();
        navigate("/order/" + order_id)


    }

    return (
        <Drawer.Root open={isOpen} onOpenChange={onOpenChange} placement={"bottom"} closeOnEscape={false} closeOnInteractOutside={false}>
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner>
                    <Drawer.Content>
                        <Container maxW={"md"}>
                            <Drawer.Header>
                                <Drawer.Title>Xác nhận thanh toán</Drawer.Title>

                            </Drawer.Header>

                            <Drawer.Body>
                                <div style={{ display: "flex", gap: 8, flexDirection: "column" }}>


                                    <Text>Ảnh chụp màn hình chuyển khoản</Text>
                                    <FileUpload.Root accept="image/*" onFileChange={onFileChange}>
                                        <FileUpload.HiddenInput />
                                        <FileUpload.Trigger asChild>

                                            <Button variant="outline" size="sm">
                                                <LuFileImage /> Chọn
                                            </Button>
                                        </FileUpload.Trigger>
                                        <div style={{ marginTop: 8 }}>
                                            <FileUploadList />
                                        </div>

                                    </FileUpload.Root>
                                </div>

                            </Drawer.Body>
                            <Drawer.Footer>
                                <Button variant="outline" onClick={close}>Huỷ</Button>

                                <Button variant="outline" onClick={paymentConfirm}>Xác nhận</Button>

                            </Drawer.Footer>

                        </Container>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>)

}
const FileUploadList = () => {
    const fileUpload = useFileUploadContext()
    const files = fileUpload.acceptedFiles
    if (files.length === 0) return null
    return (
        <FileUpload.ItemGroup>
            {files.map((file) => (
                <FileUpload.Item
                    w="auto"
                    boxSize="20"
                    p="2"
                    file={file}
                    key={file.name}
                >
                    <Image src={URL.createObjectURL(file)} objectFit={"contain"} style={{ width: "100%", height: "100%" }}></Image>
                    {/* <FileUpload.ItemPreviewImage objectFit={"contain"} /> */}
                    <Float placement="top-end">
                        <FileUpload.ItemDeleteTrigger boxSize="4" layerStyle="fill.solid">
                            <LuX />
                        </FileUpload.ItemDeleteTrigger>
                    </Float>
                </FileUpload.Item>
            ))}
        </FileUpload.ItemGroup>
    )
}

export default memo(Cart)